import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { Dashboard } from '../../../../models/dashboard/dashboard.models';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
import { DashboardView } from '../dashboard';
import { ValidationsClientService } from '../../../../services/validations/validations-client.service';
import { Guid } from '../../../../utilities/guid';
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";

@transient()
@autoinject()
export class AddNewDashboardDialog {
    private _dashboardViewModel: DashboardView;

    public globalDashboardSelected: Dashboard;
    public dashboard: Dashboard;
    public isNew: boolean = true;
    public globalDashboards: Dashboard[] = [];
    public atRoleLevel: boolean = false;

    constructor(private dialogClient: DialogClientService,
        private dashboardClientService: DashboardClientService,
        private validationsClientService: ValidationsClientService) {
        this.dashboard = {
            id: 0,
            createdDate: new Date(),
            dashboardId: 0,
            name: "",
            identifier: Guid.generateGuid(),
            entityType: EntityTypes.Dashboard
        };
    }

    cancel() {
        this.dialogClient.hide();
    }

    saveDashboard() {
        return new Promise<void>((resolve, reject) => {
            if (!this.isNew && this.globalDashboardSelected) {
                this.dashboard = this.globalDashboardSelected;
            }

            this.dashboardClientService.getWidgetsForDashboard(this.dashboard.dashboardId).then(x => {
                this.dashboardClientService.persistDashboard(this.dashboard, x.dashboardWidgets, this.atRoleLevel, false, !this.isNew)
                    .then(response => {
                        if (response.validationResult && response.validationResult.hasError) {
                            this.validationsClientService.showValidationErrors(response.validationResult);
                            reject();
                        }
                        else {
                            this._dashboardViewModel.dashboards.push(response.dashboard);
                            this._dashboardViewModel.onDashboardSelected(null, response.dashboard);
                            this._dashboardViewModel.reloadTabs();
                            this.dialogClient.hide();
                        }
                        resolve();
                    }).catch(reject);
            })
        });
    }

    public isDashboardChecked(index: number) {
        return index == 0;
    }

    activate(model: DashboardView) {
        this._dashboardViewModel = model;

        const promise1 = this.dashboardClientService.getDashboardsForUser();
        const promise2 = this.dashboardClientService.getGlobalDashboardsForUser();

        Promise.all([promise1, promise2]).then(x => {
            const appliedDashboards = x[0].dashboards.map(y => y.dashboardId);

            this.globalDashboards = x[1].dashboards.filter(x => appliedDashboards.indexOf(x.dashboardId) == -1);
        });
    }
}
